module.exports = "<div class=\"ui padded grid\">\n  <div class=\"sixteen wide column\">\n    <div class=\"ui yellow message\">{{ $t('message.personalListEmpty') }}</div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/personal/template.html
// module id = 86
// module chunks = 0